import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';
import { useAuth } from '../context/AuthContext';

const stars = n => '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
const ratingColor = n => n >= 4 ? 'var(--green)' : n === 3 ? 'var(--amber)' : 'var(--red)';

export default function Feedback() {
  const { isAdmin } = useAuth();
  const [data, setData] = useState({ rows: [], stats: { n:0, avg:null, positive:0, negative:0, distribution:{} } });
  const [f, setF] = useState({ rating:'', search:'', from:'', to:'' });
  const load = useCallback(() => {
    const params = {}; Object.entries(f).forEach(([k,v]) => { if (v) params[k]=v; });
    api.get('/feedback', { params }).then(r => setData(r.data)).catch(()=>{});
  }, [f]);
  useEffect(() => { load(); }, [load]);

  if (!isAdmin) return <div style={{ padding:40, color:'var(--text2)', textAlign:'center' }}>Admin access required</div>;
  const s = data.stats || {};
  const dist = s.distribution || {};
  const maxN = Math.max(1, ...Object.values(dist));

  return (
    <div>
      <div style={{ marginBottom:16 }}>
        <h2 style={{ fontSize:18, fontWeight:600, marginBottom:4 }}>Ticket Feedback</h2>
        <p style={{ fontSize:13, color:'var(--text2)' }}>Star ratings staff gave after their tickets were resolved.</p>
      </div>

      {/* Summary */}
      <div className="flex-gap" style={{ gap:16, marginBottom:18, flexWrap:'wrap' }}>
        <div className="card" style={{ padding:'14px 18px', minWidth:150 }}>
          <div style={{ fontSize:28, fontWeight:700, color:'#f5a623' }}>{s.avg ? Number(s.avg).toFixed(2) : '—'} <span style={{ fontSize:16 }}>★</span></div>
          <div style={{ fontSize:12, color:'var(--text2)' }}>Average rating · {s.n || 0} responses</div>
        </div>
        <div className="card" style={{ padding:'14px 18px', flex:1, minWidth:240 }}>
          {[5,4,3,2,1].map(n => (
            <div key={n} style={{ display:'flex', alignItems:'center', gap:8, fontSize:12, marginBottom:3 }}>
              <span style={{ width:34, color:'#f5a623' }}>{n} ★</span>
              <div style={{ flex:1, background:'var(--bg3)', borderRadius:4, height:10 }}>
                <div style={{ width:`${((dist[n]||0)/maxN)*100}%`, background:ratingColor(n), height:'100%', borderRadius:4 }} />
              </div>
              <span style={{ width:28, textAlign:'right', color:'var(--text2)' }}>{dist[n]||0}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Filters */}
      <div className="flex-gap" style={{ gap:8, marginBottom:12, flexWrap:'wrap' }}>
        <select value={f.rating} onChange={e => setF(s=>({...s,rating:e.target.value}))} style={{ padding:'6px 8px' }}>
          <option value="">All ratings</option>{[5,4,3,2,1].map(n => <option key={n} value={n}>{n} star{n>1?'s':''}</option>)}
        </select>
        <input value={f.search} onChange={e => setF(s=>({...s,search:e.target.value}))} placeholder="Search ticket / comment" style={{ padding:'6px 8px', minWidth:200 }} />
        <input type="date" value={f.from} onChange={e => setF(s=>({...s,from:e.target.value}))} style={{ padding:'6px 8px' }} />
        <input type="date" value={f.to} onChange={e => setF(s=>({...s,to:e.target.value}))} style={{ padding:'6px 8px' }} />
      </div>

      <div className="card" style={{ padding:0, overflow:'hidden' }}>
        {!data.rows.length ? <div className="empty-state"><p>No feedback yet.</p></div> : (
          <div className="table-wrap"><table>
            <thead><tr><th>When</th><th>Ticket</th><th>Rating</th><th>Comment</th><th>Staff</th><th>Handled by</th><th>Campus</th></tr></thead>
            <tbody>{data.rows.map(r => (
              <tr key={r.task_id}>
                <td style={{ fontSize:12, whiteSpace:'nowrap' }}>{new Date(r.created_at).toLocaleString()}</td>
                <td className="mono" style={{ fontSize:12 }}>{r.ticket_ref}<div style={{ color:'var(--text2)' }}>{r.title}</div></td>
                <td style={{ color:ratingColor(r.rating), fontSize:15, whiteSpace:'nowrap' }} title={`${r.rating}/5`}>{stars(r.rating)}</td>
                <td style={{ fontSize:12 }}>{r.comment || '—'}</td>
                <td style={{ fontSize:12 }}>{r.user_name || '—'}</td>
                <td style={{ fontSize:12 }}>{r.handled_by || '—'}</td>
                <td style={{ fontSize:12, color:'var(--text2)' }}>{r.campus_name || '—'}</td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </div>
    </div>
  );
}
